import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Landmark Address in Central Mumbai's Sion",
    "Landscaped Greens and Jogging Tracks",
    "Grand Clubhouse with Fitness & Wellness Amenities",
  ];
  const highlights2 = [
    "Indoor Games, Swimming Pool & Kids' Play Zones",
    "Spacious Party Hall & Multipurpose Community Area",
    "Round-the-Clock Security & EV-Enabled Parking",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Step into a world of timeless sophistication at Raymond Realty Sion—a
        landmark residential development located in one of Central Mumbai's most
        iconic neighbourhoods. Crafted by Raymond Realty, a name synonymous with
        trust and quality, this project blends refined architecture with
        thoughtful design to elevate everyday living.
        <br />
        At Raymond Realty Sion, you don't just invest in a home—you claim a
        lifestyle of unmatched convenience, comfort, and community. With
        meticulously planned layouts, modern amenities, and a prime address,
        this new launch redefines luxury for the urban elite. Whether you're a
        family seeking space or an investor looking for value, Raymond Sion
        delivers on every promise.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
